import {collection, getDocs, query, where} from 'firebase/firestore';
import {db} from '../firebaseConfig';
import {IEmployee, Department, DEPARTMENTS} from "./interfaces";
import {firestoreCollections} from './firestoreConstants';

/**
 * Fetches employees from Firestore based on the specified department and filters.
 * @param department - The department to filter employees by.
 * @returns A promise that resolves to an array of IEmployee objects.
 */
export async function fetchAvailableCrews(department: Department): Promise<IEmployee[]> {
  const employeesRef = collection(db, firestoreCollections.employees);

  const q = department === DEPARTMENTS.installation
    ? query(
      employeesRef,
      where('employmentStatus', '==', 'Active'),
      where('departmentString', '==', DEPARTMENTS.installation),
      where('seniorityString', '==', 'Team Leader (blue)'),
    )
    : query(
      employeesRef,
      where('employmentStatus', '==', 'Active'),
      where('departmentString', '==', department),
    );

  try {
    // Execute the query
    const querySnapshot = await getDocs(q);

    // Map the query results to IEmployee objects
    const employees = querySnapshot.docs.map((doc) => {
      const employeeData = doc.data();
      return {
        id: doc.id,
        ref: doc.ref,
        ...employeeData,
      } as IEmployee;
    });

    return employees;
  } catch (error) {
    console.error('Error fetching employees:', error);
    return [];
  }
}
